import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  Modal,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import Autocomplete from "../../Autocomplete";

const useStyles = makeStyles({
  root: {},
  navLink: {
    textDecoration: "none",
  },
});

const ViewPOSummaryModal = ({
  open,
  loading,
  job,
  unit,
  orders,
  handleClose,
}) => {
  const classes = useStyles();
  const [errors, setErrors] = useState({
    supplier: null,
  });
  const [availableSuppliers, setAvailableSuppliers] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  useEffect(() => {
    if (!job) return;

    const newSuppliersObj = new Map();

    newSuppliersObj.set(-1, { SUPPLIER_ID: -1, NAME: "All" });
    orders.forEach((order) => {
      const items = order.ORDER_ITEMS ? JSON.parse(order.ORDER_ITEMS) : [];

      items.forEach((item) => {
        newSuppliersObj.set(item.SUPPLIER_ID, {
          SUPPLIER_ID: item.SUPPLIER_ID,
          NAME: item.SUPPLIER_NAME || "Horizon",
        });
      });
    });

    const newSuppliers = Array.from(newSuppliersObj.values());
    setAvailableSuppliers(newSuppliers);
  }, [job, orders]);

  const handleSupplierChange = async (e, newValue) => {
    setSelectedSupplier(newValue || null);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        m: "auto",
        width: 480,
      }}
    >
      <Grid container>
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardHeader title="View PO Summary" />
            <Divider />
            <CardContent>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <Autocomplete
                      size="small"
                      label="Supplier"
                      loading={loading}
                      disabled={loading}
                      options={availableSuppliers || []}
                      getOptionLabel={(option) => option.NAME}
                      isOptionEqualToValue={(option, value) =>
                        option.SUPPLIER_ID === value?.SUPPLIER_ID
                      }
                      value={selectedSupplier}
                      onChange={handleSupplierChange}
                    />
                    {errors.supplier && (
                      <FormHelperText error>{errors.supplier}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardActions>
              <Grid container justifyContent="flex-end">
                <Grid item>
                  <Grid container spacing={2}>
                    <Grid item>
                      <Link
                        to={
                          job && selectedSupplier
                            ? `/po/summary?jid=${job.JOB_ID}${
                                selectedSupplier.SUPPLIER_ID >= 0
                                  ? `&sid=${selectedSupplier.SUPPLIER_ID}`
                                  : ""
                              }&unit=${unit.UNIT_ID}`
                            : "#"
                        }
                        className={classes.navLink}
                        target="_blank"
                      >
                        <Button
                          variant="contained"
                          disabled={loading || !selectedSupplier}
                        >
                          View
                        </Button>
                      </Link>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="outlined"
                        onClick={handleClose}
                        disabled={loading}
                      >
                        Close
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ViewPOSummaryModal;
